export default "__VITE_ASSET__Ci39DFqy__"